if (!customElements.get("a-sale-price")) {
  customElements.define(
    "a-sale-price",
    class ASalePrice extends HTMLElement {
      constructor() {
        super();
        this.dealActive = (this.dataset.dealActive || "false") === "true";
      }

      connectedCallback() {
        // Cache blocks (these exist for every variant)
        this.dealWraps = this.querySelectorAll(".deal-wrap");
        this.normals = this.querySelectorAll(".normal-price-block");

        // Initialize on load (selected variant already rendered visible, but we re-assert)
        const initial = this._getSelectedVariantId();
        if (initial) this.update(initial);

        // Dawn-style pubsub (works on most modern themes)
        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const id = event?.data?.variant?.id?.toString();
            if (id) this.update(id);
          });
        }

        // Fallback: listen to changes on variant pickers (if theme doesn’t use PUB_SUB)
        this._bindFallbackVariantListeners();
      }

      disconnectedCallback() {
        if (this.unsub) this.unsub();
      }

      update(id) {
        // Hide everything
        this.dealWraps.forEach((el) => el.classList.add("hidden"));
        this.normals.forEach((el) => el.classList.add("hidden"));

        // Show correct block for this variant depending on dealActive
        if (this.dealActive) {
          const dealWrap = this.querySelector(`.deal-wrap[data-variant="${id}"]`);
          if (dealWrap && !dealWrap.classList.contains("no-deal")) {
            dealWrap.classList.remove("hidden");
            return;
          }
        }

        const normal = this.querySelector(`.normal-price-block[data-variant="${id}"]`);
        if (normal && !normal.classList.contains("no-normal")) {
          normal.classList.remove("hidden");
        }
      }

      _getSelectedVariantId() {
        // Try to read current variant id from URL (?variant=) first
        const params = new URLSearchParams(window.location.search);
        const urlId = params.get("variant");
        if (urlId) return urlId.toString();

        // Fallback: find first visible block and use its data-variant
        const visibleDeal = this.querySelector(`.deal-wrap:not(.hidden)[data-variant]`);
        if (visibleDeal) return visibleDeal.getAttribute("data-variant");

        const visibleNormal = this.querySelector(`.normal-price-block:not(.hidden)[data-variant]`);
        if (visibleNormal) return visibleNormal.getAttribute("data-variant");

        return null;
      }

      _bindFallbackVariantListeners() {
        // Common selectors for variant pickers in Shopify themes
        const form = this.closest("form[action*='/cart/add']") || document.querySelector("form[action*='/cart/add']");
        if (!form) return;

        const onChange = () => {
          const idInput = form.querySelector('input[name="id"]');
          const id = idInput?.value?.toString();
          if (id) this.update(id);
        };

        form.addEventListener("change", onChange);
      }
    }
  );
}